export default __webpack_public_path__ + "static/media/SIFA_FR_EPILOGUE02.a9ec4a63.mp3";